var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20H14C14.2406 20 14.4732 19.9133 14.6551 19.7557C14.8369 19.5981 14.9558 19.3802 14.99 19.142L16.867 6H18V4H16.618L14.894 0.553C14.8112 0.386773 14.6836 0.246948 14.5257 0.149253C14.3678 0.0515585 14.1857 -0.000130601 14 2.47811e-07H4C3.621 2.47811e-07 3.275 0.214 3.105 0.553L1.382 4H0V6H1.133L3.01 19.142C3.04417 19.3802 3.16309 19.5981 3.34494 19.7557C3.52678 19.9133 3.75936 20 4 20ZM14.418 9H3.582L3.153 6H14.846L14.418 9ZM4.867 18L4.438 15H13.561L13.132 18H4.867ZM4.618 2H13.382L14.382 4H3.618L4.618 2Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.e1b2ca9618ac291cb362b4ad14f8bb75.svg";
export { ForwardRef as ReactComponent };